import { Spacer } from '@dot/design-system';
import { useTranslation } from 'react-i18next';

import { SecuredByBadge } from '@/components/SecuredByBadge/SecuredByBadge';
import { CaptureWrapper } from '@/components/capture-wrapper';
import * as GSC from '@/styles/GlobalStyles';

/**
 * Manifest-driven `nfc_capture` UI step — **web stub**.
 *
 * Innovatrics DOT does not ship a Web NFC component (only Android / iOS mobile
 * SDKs). For the web flow we render an informational placeholder; the workflow
 * author should ensure the NFC step runs on the mobile SDK side (typically
 * gated by a `mobile_redirect` step that hands control off to a mobile app).
 *
 * If a session reaches this step on web, the BFF challenge (chip auth nonce)
 * is already pre-issued in `step.data.challenge` and ready to be consumed
 * by the mobile reader on the same session — but the actual chip read
 * happens outside this web component.
 */
export const NfcCapture = () => {
  const { t } = useTranslation();

  return (
    <>
      <GSC.RelativeContainer>
        <CaptureWrapper>
          <GSC.CaptureContainer>
            <h2>{t('steps.nfcCapture.title', { defaultValue: 'NFC chip reading' })}</h2>
            <p>
              {t('steps.nfcCapture.unavailable', {
                defaultValue:
                  'NFC chip reading is not available on the web. Please continue on a mobile device with NFC support.',
              })}
            </p>
          </GSC.CaptureContainer>
        </CaptureWrapper>
      </GSC.RelativeContainer>
      <Spacer $top={1}>
        <SecuredByBadge />
      </Spacer>
    </>
  );
};
